module.exports = __webpack_public_path__ + "img/nodata.25bbdc1a.svg";